import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styles from "./CashierTab.module.css";
import Deposit from "./Deposit";
import Withdraw from "./Withdraw";
import DWHistory from "./DWHistory";
import CashToCredit from "./CashToCredit";

const topTabs = [
  { id: "deposit", label: "ฝากเงิน", icon: "mdi:wallet-plus" },
  {
    id: "cashtocredit",
    label: "แลกกระเป๋าเงินสด",
    icon: "mdi:swap-horizontal",
  },
  { id: "withdraw", label: "ถอนเงิน", icon: "mdi:cash-minus" },
  { id: "history", label: "ประวัติธุรกรรม", icon: "mdi:history" },
];

export default function CashierTab({
  initialTab = "deposit",
  hideTabs = false,
}) {
  const [tab, setTab] = useState(initialTab);
  const [historyTab, setHistoryTab] = useState("historyDeposit"); // historyDeposit | historyWithdraw

  useEffect(() => {
    setTab(initialTab);
  }, [initialTab]);

  return (
    <div className={styles.wrapper}>
      {!hideTabs && (
        <div className={styles.subTabs}>
          {topTabs.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`${styles.subTabBtn} ${
                tab === t.id ? styles.subTabActive : ""
              }`}
              onClick={() => setTab(t.id)}
            >
              <Icon icon={t.icon} width={20} height={20} />
              <span>{t.label}</span>
              {tab === t.id && <div className={styles.activeBar} />}
            </button>
          ))}
        </div>
      )}

      <div className={styles.panel}>
        {tab === "deposit" && <Deposit />}
        {tab === "withdraw" && <Withdraw />}
        {tab === "history" && (
          <DWHistory historyTab={historyTab} setHistoryTab={setHistoryTab} />
        )}
        {tab === "cashtocredit" && <CashToCredit />}
      </div>
    </div>
  );
}
